import { FirebaseRef } from '../lib/firebase'
export function checkExistUrl(firstNameUrl) {
  return new Promise(resolve => {
    const ref = FirebaseRef.child('reQuest').orderByChild('firstNameUrl').equalTo(firstNameUrl)
    ref.on('value', (snapshot) => {
      const data = snapshot.val() || {}
      if (Object.keys(data).length > 0) {
        return resolve({ isExist: true })
      }
      return resolve({ isExist: false })
    })

  })

}

export function createRequest(formData) {
  return new Promise(resolve => {
    const Ref = FirebaseRef.push()
    const key = Ref.getKey()

    return FirebaseRef.child(`reQuest/${key}`)
      .set({
        ...formData
      })
      .then(() => {

        return resolve({ isSuccess: true, key })
      })
      .catch(err => {
        return resolve({ isSuccess: false, err })
      })
  })
}

